import { useLanguageValue } from '@ipc/ipc-core';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuthInfo from '../../common/AuthInfo';
import LanguageSwitcher from '../../common/LanguageSwitcher';
import ipcLogoSmall from '../../../images/ipc_logo_small.png';
import Template from './resources/PARIS_Front-End_User_Guide.pdf';
import { RightContainerWrapper, UserGuideWrapper } from './styles';

export const AppHeaderRightContainerComponent = () => {
  const [{ currentLanguage }] = useLanguageValue();
  return (
    <div className="header-right-container">
      <AuthInfo />
      <RightContainerWrapper>
        <UserGuideWrapper href={Template} download>
          <FontAwesomeIcon icon="question-circle" />
        </UserGuideWrapper>
      </RightContainerWrapper>
      <div className="vertical-divider" />
      <img
        className="logo"
        alt="IPC logo"
        src={ipcLogoSmall}
      />
      <LanguageSwitcher currentLanguage={currentLanguage} />
    </div>
  );
};

export default AppHeaderRightContainerComponent;
